import { useSelectorTyped } from 'common/store/useSelectorTyped';
import server from 'common/utils/server';

export const initialState = {
  sessions: [],
  sessionCount: 0,
  totalPages: 0,
  drafts: [],
  lastShareDate: null,
  loaded: false,
  loading: false,
};

export const coachingSessionLogState = (state = initialState, action) => {
  switch (action.type) {
    case 'COACHING_SESSION/reset_state': {
      return initialState;
    }
    case 'coaching_session_log/START_LOADING': {
      return { ...state, loading: true };
    }
    case 'coaching_session_log/RECEIVE_SESSIONS': {
      const { sessions, sessionCount, totalPages, drafts, lastShareDate } =
        action;
      return {
        ...state,
        sessions,
        sessionCount,
        totalPages,
        drafts,
        lastShareDate,
        loaded: true,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const loadCoachingSessionHistory =
  ({ employeeId }) =>
  async (dispatch, getState) => {
    const { loading } = getState().coachingSessionLogState;
    const { historyPage } = getState().coachingSession;

    // If we're currently loading the session logs, there's no need to create another
    // call for that.
    if (loading) return;

    dispatch({ type: 'coaching_session_log/START_LOADING' });
    const { sessions, sessionCount, totalPages, drafts, lastShareDate } =
      await server.get(
        `/api/v1/coaching/coaching_session/?page=${historyPage}&employee_id=${employeeId}`
      );
    dispatch({
      type: 'coaching_session_log/RECEIVE_SESSIONS',
      sessions,
      sessionCount,
      totalPages,
      drafts,
      lastShareDate,
    });
  };

export const usePreviousSessionId = coachingSessionId => {
  const sessions = useSelectorTyped(
    state => state.coachingSessionLogState.sessions
  );
  const currentSessionIdx = sessions.findIndex(s => s.id === coachingSessionId);

  return sessions[currentSessionIdx + 1]?.id;
};
